import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FiShoppingCart } from 'react-icons/fi';
import { ContentWrapper, ScrollingContent } from '../../../BookingPage/styles';
import TicketItem from '../../../../components/Store/Tickets/TicketItem';
import PriceCentsCalc from '../../../../components/PriceCentsCalc';
import { FlexFlow } from '../../../../components/styles/Layout';
import Gallery from '../../../../components/Gallery';
import TimerBlock from '../../../../components/Store/TimeBlock';
import ColorsPicker from '../../../../components/Store/ColorsPicker';
import ContentPicker from '../../../../components/Store/ContentPicker';
import AmountField from '../../../../components/Store/AmountField';
import {
  LPText, CssButton, CardArea, CardTextArea, CardFooter, IconWrapper,
} from './styles';

import {} from '../../../styles';

// eslint-disable-next-line react/prop-types
const ProductPageBody = ({ product }) => {
  const {
    productTitle: title,
    productPrice: price,
    productOriginalPrice: originalPrice,
    productDescription: description,
    productImages,
    colors,
    sizes,
    minAmount,
    maxAmount,
    endDate,
  } = product;

  const [selectedColor, setSelectedColor] = useState({ value: '', label: '' });
  const [selectedSize, setSelectedSize] = useState({ value: '', label: '' });

  const [itemsAmount, setItemsAmount] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const minValue = minAmount || 0;
  // eslint-disable-next-line no-unused-vars
  const maxValue = maxAmount || 99;
  // eslint-disable-next-line no-unused-vars
  const selectOptions = [];

  // for (let index = minValue; index < maxValue; index += 1) {
  //   selectOptions.push({
  //     label: `${index}`,
  //     value: `${index}`,
  //   });
  // }
  return (
    <ContentWrapper nopadding>
      <ScrollingContent nopadding>
        <CardArea noborder>
          <CardTextArea noMargin>
            <TicketItem
              noMargin
              withBorders
              noPadding
              ticketContent={(
                <FlexFlow column>
                  <LPText noMargin large>
                    {title}
                  </LPText>
                  <FlexFlow splitSpace="0.5em">
                    <LPText noMargin mid bold red>
                      <PriceCentsCalc currency="$" priceCents={price} toFixed={2} />
                    </LPText>
                    <LPText noMargin mid stroked>
                      <PriceCentsCalc currency="$" priceCents={originalPrice} toFixed={2} />
                    </LPText>
                  </FlexFlow>
                </FlexFlow>
              )}
              ticketValue={(
                <IconWrapper>
                  <FiShoppingCart />
                </IconWrapper>
              )}
            />
          </CardTextArea>
          <Gallery images={productImages} />

          <LPText centered>{description}</LPText>

          <CardTextArea noMargin>
            <TimerBlock inStock={99} toDate={endDate} />
          </CardTextArea>

          <CardTextArea>
            <FlexFlow column splitSpace="0.5em" padding="1em 0 0">
              <FlexFlow column>
                <FlexFlow splitSpace="0.5em">
                  <LPText uppercase>Color:</LPText>

                  <LPText bold uppercase>
                    {selectedColor.label}
                  </LPText>
                </FlexFlow>
                <ColorsPicker
                  onChange={(item) => setSelectedColor(item)}
                  items={colors}
                  selectedItem={selectedColor}
                />
              </FlexFlow>

              <FlexFlow column>
                <FlexFlow splitSpace="0.5em">
                  <LPText uppercase>Size:</LPText>

                  <LPText bold uppercase>
                    {selectedSize.label}
                  </LPText>
                </FlexFlow>

                <ContentPicker
                  onChange={(item) => setSelectedSize(item)}
                  items={sizes}
                  selectedItem={selectedSize}
                />
              </FlexFlow>
            </FlexFlow>
          </CardTextArea>
          <CardTextArea bordered>
            <FlexFlow padding="1em 0" splitSpace="1em">
              <AmountField
                value={itemsAmount}
                updateValue={(v) => setItemsAmount(+v)}
                min={minAmount}
                max={maxAmount}
              />
              <CssButton disabled={itemsAmount === 0} className="pay_btn" variant="outlined">
                Add to Cart
              </CssButton>
            </FlexFlow>
          </CardTextArea>
        </CardArea>
        <CardFooter>
          <CssButton disabled={itemsAmount === 0} className="pay_btn" variant="outlined">
            View Cart
            <span className="pay_amount">
              <PriceCentsCalc currency="$" priceCents={price * itemsAmount} toFixed={2} />
            </span>
          </CssButton>
        </CardFooter>
      </ScrollingContent>
    </ContentWrapper>
  );
};

ProductPageBody.defaultProps = {
  product: {},
};

ProductPageBody.propTypes = {
  product: PropTypes.shape(),
};

export default ProductPageBody;
